module.exports = __webpack_public_path__ + "img/investment_4.863917e9.jpg";